export const getCookies = (key: string) => {
  const name = `${key}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      const cookieVal = c.substring(name.length, c.length);
      // console.log(`Cookie value: ${cookieVal}`);
      return cookieVal;
    }
  }
  console.log("Cookie not found");
};

export const setCookies = (key: string, data: any) => {
  // console.log(key, data, "line199")
  const date = new Date();
  date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // Expiration in 30 days
  const expires = "expires=" + date.toUTCString();
  document.cookie = key + "=" + encodeURIComponent(data) + ";" + expires + "; path=/";
};

export const removeCookies = (key: string, date: Date) => {
  document.cookie = `${key}=; expires=${date || new Date()}; path=/`;
};